import { useContext } from "react";
import { IUser } from "../constants/app.dto";
import { getUserProfile, upsertUserProfile } from "../apis/private.api";
import { userContext, userContextProps } from "../../context/userContext";
import { userInformation, userInitialState } from "../../context/states/userState";
import { deleteUserAuthData, saveUserAuthData } from "../helpers/utilities";

interface IUseUser extends userContextProps{
  initUserSession: (...params: any) => void;
  endUserSession: () => void;
  refreshUserSession: () => void;
}

export const useUser = (): IUseUser => {
  
  const user = useContext(userContext);

  const initUserSession = async (auth: any , profileData: IUser) => {
    // this saves/updates user token
    saveUserAuthData(auth);

    const userName = auth.attributes.name?.split(" ** ") ?? [];
    const profile = {
      ...userInformation, 
      name: userName[0] ?? '',
      lastName: userName[userName.length -1] ?? '', 
      email: auth.attributes.email, 
      cellPhone: auth.attributes.phone_number ?? ''
    }
    
    const userData = profileData ?? await upsertUserProfile(profile);

    user.setDataAll({
      ...userInitialState,
      ...userData,

      name: userData?.name || (userName ? userName[0] : ''),
      lastName: userData?.lastName || (userName ? userName[1] : ''),

      cellPhone: userData?.cellPhone || auth.attributes.phone_number,
      email: userData?.email || auth.attributes.email,
      isLogged: true,
    })
  };

  const endUserSession = () => {
    deleteUserAuthData();
    user.setDataAll(userInitialState);
  };

  const refreshUserSession = async () => {
    const userData = await getUserProfile(user.getDataByAttributeName("email"));
    user.setDataAll({...user.getDataAll() , ...userData});
  }

  return {
    initUserSession,
    endUserSession,
    refreshUserSession,
    ...user,
  };
}